module.exports = __webpack_public_path__ + "static/media/Calendar.44a52e65.svg";